import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/** Reads a feature_flags row; missing row or error = off (fail closed). */
export function useFeatureFlag(key: string): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    supabase.from("feature_flags").select("is_active").eq("key", key).maybeSingle()
      .then(({ data }) => { if (active) setEnabled(!!data?.is_active); });
    return () => { active = false; };
  }, [key]);
  return enabled;
}
